import { baseAPI } from "../baseApi"
import { buildTableQueryParams } from "./tablesApiSlice";

export const diagnosticsApiSlice = baseAPI.injectEndpoints({
    endpoints: builder => ({
        fetchMeasureTypes: builder.query<any, any>({
            query: () => ({
                url: `diagnostics/MeasureTypes`
            })
        }),
        fetchRoadDiagnosticsSegments: builder.query<any, any>({
            query: (queryParams) => {
                const queryString = buildTableQueryParams(queryParams);
                return {
                    url: `objects/RoadDiagnosticsSegments?${queryString}`,
                };
            }
        }),
        fetchNormativityAggregateReport: builder.mutation<any, any>({
            query: ({ Year = new Date().getFullYear(), HighwayNetworks, PavementTypes = [], Raions = [], Categories = [] }) => ({
                url: `diagnostics/aggregateNormativity`,
                method: "POST",
                body: { HighwayNetworks, Year, PavementTypes, Raions, Categories },
                headers: {
                    'Content-Type': 'application/json',
                }
            })
        }),
        fetchRoadMeasures: builder.query<any, any>({
            query: (queryParams) => {
                const queryString = buildTableQueryParams(queryParams);
                return {
                    url: `diagnostics/RoadMeasures?${queryString}`,
                };
            }
        }),
        fetchDefectSegments: builder.query<any, any>({
            query: (queryParams) => {
                const queryString = buildTableQueryParams(queryParams);
                return {
                    url: `diagnostics/DefectSegments?${queryString}`,
                };
            }
        }),
        fetchRoadMeasureResults: builder.query<any, any>({
            query: ({ url, ...queryParams }) => {
                const queryString = buildTableQueryParams(queryParams);
                return {
                    url: `${url}?${queryString}`,
                };
            }
        }),
        fetchPathNormativities: builder.query<any, any>({
            query: (queryParams) => {
                const queryString = buildTableQueryParams(queryParams);
                return {
                    url: `diagnostics/PathNormativities?${queryString}`
                }
            }
        }),




        fetchRoadMeasuresMultipleFilters: builder.query<any, any>({
            query: (args) => ({
                url: `diagnostics/RoadMeasures/?$skip=${args.skip}&$orderby=${args.order}&`
                    + (args.pages ? '$inlinecount=allpages' : '')
                    + (args.top ? `&$top=${args.top}` : '')
                    + `&$filter=(${args.filterStringArray.join(' and ')} and pathId eq ${args.pathId})`
            })
        }),
        fetchRoadMeasureResultsMultipleFilters: builder.query<any, any>({
            query: (args) => ({
                url: `${args.way}?$skip=${args.skip}${args.order ? `&$orderby=${args.order}` : ''}`
                    + (args.pages ? '&$inlinecount=allpages' : '')
                    + (args.top ? `&$top=${args.top}` : '')
                    + `&$filter=(${args.filterStringArray.join(' and ')})`
            })
        }),
        fetchMeasureLineCount: builder.query<any, any>({
            query: (args) => ({
                url: `diagnostics/measureLineCount?PathId=${args.pathId}&MeasureTypeId=${args.measureTypeId}&MinYear=${args.minYear}&MaxYear=${args.maxYear}&$ForNearest=${args.forNearest}`
            })
        }),
        fetchActualRoadMeasureResults: builder.query<any, any>({
            query: (args) => ({
                url: `${args.way}?$skip=${args.skip}&$orderby=${args.order}&`
                    + (args.pages ? '$inlinecount=allpages' : '')
                    + (args.top ? `&$top=${args.top}` : '')
                    + `&$filter=(${args.filterStringArray.join(' and ')} and pathId eq ${args.pathId})`
            })
        })
    })
})

export const {
    useFetchRoadDiagnosticsSegmentsQuery,
    useLazyFetchRoadDiagnosticsSegmentsQuery,
    useFetchRoadMeasuresQuery,
    useFetchMeasureTypesQuery,
    useFetchRoadMeasureResultsQuery,
    useLazyFetchRoadMeasureResultsQuery,
    useFetchRoadMeasureResultsMultipleFiltersQuery,
    useFetchMeasureLineCountQuery,
    useFetchRoadMeasuresMultipleFiltersQuery,
    useFetchActualRoadMeasureResultsQuery,
    useLazyFetchPathNormativitiesQuery,
    useFetchPathNormativitiesQuery,
    useFetchDefectSegmentsQuery,
    useLazyFetchDefectSegmentsQuery,
    useFetchNormativityAggregateReportMutation
} = diagnosticsApiSlice
